import { Methods } from '@newview/infrastructure';
import {BasicDataBaseApi} from "./BasicDataBaseApi";


export class BusinessworkflowApi extends BasicDataBaseApi {

  public get ControllerName(): any {
    return 'businessworkflow'
  }

  /**
   * 分页获取
   * @param params
   */
  public getListPageBySystemId(current,size,subSystemId,subProjectId){
    return this.send({current:current,size:size,subSystemId:subSystemId,subProjectId:subProjectId},"getListPageBySystemId",Methods.GET)
  }
 
  
  /**
   * 保存流程基本信息，及流程节点信息
   * @param param 
   */
   public saveBusinessWorkFlowAndStep(param){
    return this.send(param,"saveBusinessWorkFlowAndStep",Methods.POST)
  }
  /**
   * 更新流程基本信息，及流程节点信息
   * @param param 
   */
   public updateBusinessWorkFlowAndStep(param){
    return this.send(param,"updateBusinessWorkFlowAndStep",Methods.POST)
  }
   /**
   * 删除流程信息
   * @param param 
   */
     public delWorkFlowById(param){
      return this.send(param,"delWorkFlowById",Methods.POST)
    }

    /**
     * 根据条件获取对象
     * @param param
     */
    public getEntityByParams(param){
        return this.send(param,"getEntityByParams",Methods.GET)
    }
  

  
 

}